export { default } from './MyPremoderationTasksList';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/MyPremoderationTasksList/index.js